import BaseControlTypeConst from "./BaseControlTypeConst"

export default class BadgeTypeConst extends BaseControlTypeConst {
    static SEVERITY = 'severity'
    static SIZE = 'size'
}